module.exports = __webpack_public_path__ + "media/assets/images/blog/colored_email-small-fc1fdf75bdfe67dd3607358b86bd3a5b.png";